module.exports = __webpack_public_path__ + "static/media/splash-banner-title-mob.a4fc778a.png";